class CustomCarousel extends HTMLElement {
	constructor() {
		super();
		this.splide = null;
	}

	connectedCallback() {
		this.filterScheduledItems();
		const enableDesktopCarousel = this.getAttribute('enable-desktop-carousel') === 'true';
		const enableMobileCarousel = this.getAttribute('enable-mobile-carousel') === 'true';

		// Get grid settings from attributes
		const desktopColumns = parseInt(this.getAttribute('desktop-columns')) || 1;
		const mobileColumns = parseInt(this.getAttribute('mobile-columns')) || 1;
		const desktopGap = parseInt(this.getAttribute('desktop-gap')) || 0;
		const mobileGap = parseInt(this.getAttribute('mobile-gap')) || 0;

		// Add new attribute parsing
		const autoplay = this.getAttribute('autoplay') === 'true';
		const interval = parseInt(this.getAttribute('interval')) || 5000;
		const showArrows = this.getAttribute('show-arrows') !== 'false';
		const showDots = this.getAttribute('show-dots') !== 'false';
		const perMove = parseInt(this.getAttribute('per-move')) || 1;
		const infiniteLoop = this.getAttribute('infinite-loop') !== 'false';

		// Initialize Splide based on screen size and settings
		const isMobile = window.innerWidth < 750; // Match Shopify's breakpoint

		if ((isMobile && enableMobileCarousel) || (!isMobile && enableDesktopCarousel)) {
			this.initSplide({
				perPage: isMobile ? mobileColumns : desktopColumns,
				gap: `${isMobile ? mobileGap : desktopGap}px`,
				autoplay: autoplay,
				interval: interval,
				arrows: showArrows,
				pagination: showDots,
				perMove: perMove,
				type: infiniteLoop ? 'loop' : 'slide',
			});
		} else {
			// Remove Splide classes if carousel is not enabled for current device
			this.classList.remove('splide');
			const track = this.querySelector('.splide__track');
			const list = this.querySelector('.splide__list');

			if (track && list) {
				// Unwrap the track while preserving the list and its contents
				track.parentNode.insertBefore(list, track);
				track.parentNode.removeChild(track);

				// Remove Splide classes from list and slides
				list.classList.remove('splide__list');
				list.querySelectorAll('.splide__slide').forEach((slide) => {
					slide.classList.remove('splide__slide');
				});
			}
		}

		// Handle resize events to reinitialize when needed
		window.addEventListener('resize', this.handleResize.bind(this));
	}

	disconnectedCallback() {
		if (this.splide) {
			this.splide.destroy();
		}
		window.removeEventListener('resize', this.handleResize.bind(this));
	}

	handleResize() {
		const enableDesktopCarousel = this.getAttribute('enable-desktop-carousel') === 'true';
		const enableMobileCarousel = this.getAttribute('enable-mobile-carousel') === 'true';
		const isMobile = window.innerWidth < 750;

		// Determine if we need to reinitialize
		const shouldBeCarousel = (isMobile && enableMobileCarousel) || (!isMobile && enableDesktopCarousel);
		const isCurrentlyCarousel = this.splide !== null;

		if (shouldBeCarousel !== isCurrentlyCarousel) {
			// Reload the page to reinitialize
			window.location.reload();
		}
	}

	initSplide(deviceSpecificOptions = {}) {
		// Base options
		const options = {
			type: 'slide',
			arrows: true,
			pagination: true,
			autoplay: false,
			interval: 5000,
			speed: 400,
			perMove: 1,
			...deviceSpecificOptions,
		};

		// Initialize Splide
		this.classList.add('splide');
		this.splide = new Splide(this, options);
		this.splide.mount();
	}

	filterScheduledItems() {
		const items = this.querySelectorAll('.image-link-item');
		const now = new Date();

		items.forEach((item) => {
			const enableSchedule = item.getAttribute('data-schedule-enabled') === 'true';
			if (!enableSchedule) return;

			const startDateStr = item.getAttribute('data-schedule-start-date');
			const endDateStr = item.getAttribute('data-schedule-end-date');
			const startTimeStr = item.getAttribute('data-schedule-start-time');
			const endTimeStr = item.getAttribute('data-schedule-end-time');

			if (!this.isItemVisible(now, startDateStr, endDateStr, startTimeStr, endTimeStr)) {
				item.remove();
			} else {
				item.removeAttribute('data-schedule-enabled');
			}
		});
	}

	isItemVisible(now, startDateStr, endDateStr, startTimeStr, endTimeStr) {
		// Helper to parse DD-MM-YYYY
		const parseDate = (dateStr) => {
			if (!dateStr) return null;
			const parts = dateStr.split('-');
			if (parts.length !== 3) return null;
			const [day, month, year] = parts.map((num) => parseInt(num, 10));
			return new Date(year, month - 1, day);
		};

		// Helper to parse HH:MM
		const parseTime = (timeStr) => {
			if (!timeStr) return null;
			const parts = timeStr.split(':');
			if (parts.length !== 2) return null;
			const [hours, minutes] = parts.map((num) => parseInt(num, 10));
			return { hours, minutes };
		};

		// 1. Check Date Range
		const startDate = parseDate(startDateStr);
		const endDate = parseDate(endDateStr);

		// Normalize 'now' to remove time component for date comparison
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

		if (startDate && today < startDate) return false;
		if (endDate && today > endDate) return false;

		// 2. Check Time Range (Daily)
		// If no time restrictions, it's visible (since date passed)
		if (!startTimeStr && !endTimeStr) return true;

		const currentHours = now.getHours();
		const currentMinutes = now.getMinutes();
		const currentTimeInMinutes = currentHours * 60 + currentMinutes;

		if (startTimeStr) {
			const start = parseTime(startTimeStr);
			if (start) {
				const startInMinutes = start.hours * 60 + start.minutes;
				if (currentTimeInMinutes < startInMinutes) return false;
			}
		}

		if (endTimeStr) {
			const end = parseTime(endTimeStr);
			if (end) {
				const endInMinutes = end.hours * 60 + end.minutes;
				if (currentTimeInMinutes > endInMinutes) return false;
			}
		}

		return true;
	}
}

// Register the custom element
customElements.define('custom-carousel', CustomCarousel);

// cart page block

if (location.pathname === '/cart' && !location.search) {
	window.location.href = '/?return_link=cart';
}

// Open cart drawer when redirected with ?return_link=cart
if (new URLSearchParams(location.search).has('return_link')) {
	const cartDrawerObserver = new MutationObserver(() => {
		let cartDrawer = document.querySelector('cart-drawer');
		if (cartDrawer) {
			cartDrawer.show();
			cartDrawerObserver.disconnect(); // Stop observing after cart opens
		}
	});
	cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

	// Remove return_link=cart from the URL
	const newUrl = location.href.replace(/[?&]return_link=cart/g, '');
	history.replaceState({}, document.title, newUrl);
}

// Handle browser back button to close cart
window.addEventListener('popstate', function (event) {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !location.search.includes('cartOpen=true')) {
		cartDrawer.close();
	} else if (event.state?.cart === 'show' && cartDrawer) {
		cartDrawer.show();
	}
});

// Ensure cartOpen=true is removed from URL if cart is closed
document.addEventListener('DOMContentLoaded', () => {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer && !cartDrawer.classList.contains('active')) {
		const newUrl = location.href.replace(/[?&]cartOpen=true/g, '');
		history.replaceState({}, document.title, newUrl);
	}
});

// Open cart and push cartOpen=true into history
function openCart() {
	const cartDrawer = document.querySelector('cart-drawer');
	if (cartDrawer) {
		cartDrawer.show();
		history.pushState({ cart: 'show' }, '', '?cartOpen=true');
	}
}

// rating js

// judgeme js

const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

// cart-change-handler.js - OPTIMIZED
document.addEventListener("cart:change", debounce(async (event) => {
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  console.log("Base Event:", baseEvent);
  console.log("Cart items:", cartData.items.map(item => ({
    handle: item.handle,
    title: item.product_title,
    quantity: item.quantity,
    key: item.key,
    properties: item.properties
  })));

  // Prevent infinite loops - don't process if this is from auto-removal or sync
  if (baseEvent === "gift-items:auto-remove") {
    console.log("Skipping cart:change handler for gift-items:auto-remove event");
    return;
  }

  // First handle the case of removing add-ons when main product is gone
  const mainProducts = cartData.items.filter(
    (item) => !item.properties?._main_product
  );
  const addOns = cartData.items.filter(
    (item) => item.properties?._main_product
  );

  console.log(`Total items: ${cartData.items.length}, Main products: ${mainProducts.length}, Addons: ${addOns.length}`);

  // If there are add-ons but no main products, remove ALL add-ons
  if (addOns.length > 0 && mainProducts.length === 0) {
    console.log(
      "No main products exist but add-ons found. Removing all add-ons."
    );
    await forceRemoveAllAddons(addOns);
    return; // Exit early after handling this case
  }

  // Check if any add-ons have a main product that no longer exists
  if (addOns.length > 0 && mainProducts.length > 0) {
    const orphanedAddons = addOns.filter((addon) => {
      // Find if this addon's main product still exists
      const mainProductExists = mainProducts.some(
        (main) => main.handle === addon.properties._main_product
      );
      return !mainProductExists;
    });

    if (orphanedAddons.length > 0) {
      console.log("Found orphaned add-ons to remove:", orphanedAddons);
      await forceRemoveAllAddons(orphanedAddons);
      return; // Exit early after handling this case
    }
  }

  // Handle changes to the main product quantity
  // Skip quantity sync if this event is from a sync operation itself
  if (
    baseEvent !== "addon-quantity:sync" &&
    (baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove")
  ) {
    console.log("Processing quantity changes for main products:", mainProducts.length);
    
    // For each main product
    for (const mainProduct of mainProducts) {
      console.log(`Checking main product: ${mainProduct.handle}, qty: ${mainProduct.quantity}`);
      
      // Find add-ons for this specific main product
      const relatedAddons = addOns.filter(
        (addon) => addon.properties._main_product === mainProduct.handle
      );

      console.log(`Found ${relatedAddons.length} related addons for ${mainProduct.handle}`);

      if (relatedAddons.length === 0) continue;

      // If main product quantity is 0, remove all its add-ons
      if (mainProduct.quantity === 0) {
        console.log(
          `Main product ${mainProduct.handle} has 0 quantity. Removing all its add-ons.`
        );
        await forceRemoveAllAddons(relatedAddons);
        continue;
      }

      // For ready-to-wear, blouse customization, and remove-cups items, sync quantities
      // Gift products are NOT synced and remain independent
      const syncableAddons = relatedAddons.filter((addon) => {
        console.log(`Checking addon: ${addon.handle}, title: ${addon.product_title}`);
        
        const isReadyToWear =
          addon.handle === "make-this-saree-ready-to-wear-copy" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("ready-to-wear")) ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("pre-drape")) ||
          (addon.variant_title &&
            addon.variant_title.toLowerCase().includes("ready-to-wear"));

        const isBlouseCustomization =
          addon.handle === "customise-blouse" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("blouse customization")) ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("customise blouse"));

        const isRemoveCups =
          addon.handle === "remove-cups" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("remove cups"));

        const isSyncable = isReadyToWear || isBlouseCustomization || isRemoveCups;
        console.log(`  - Is syncable: ${isSyncable} (RtW: ${isReadyToWear}, Blouse: ${isBlouseCustomization}, RemoveCups: ${isRemoveCups})`);
        
        return isSyncable;
      });

      console.log(`Found ${syncableAddons.length} syncable addons`);

      if (syncableAddons.length > 0) {
        // Check if any addon needs its quantity updated
        const needsSync = syncableAddons.some(
          (addon) => {
            console.log(`  Addon ${addon.handle}: current qty ${addon.quantity}, main product qty ${mainProduct.quantity}`);
            return addon.quantity !== mainProduct.quantity;
          }
        );

        if (needsSync) {
          console.log(
            `Syncing ${syncableAddons.length} add-ons for main product ${mainProduct.handle} to quantity ${mainProduct.quantity}`
          );
          await syncAddonQuantities(syncableAddons, mainProduct.quantity);
        } else {
          console.log(`No sync needed - quantities already match`);
        }
      }
    }
  }

  if (baseEvent === "item:add" || baseEvent === "variant:add") {
    if (typeof window.triggerConfetti === 'function') {
      window.triggerConfetti({
        particleCount: 250,
        spread: 180,
        origin: { y: 1.0, x: 0.5 },
        startVelocity: 60,
        colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
      });
    }
  }

  // Check for gift-wrapping items - should run after all other operations
  await checkAndRemoveGiftWrappingItems(cartData);

  // Process freebies based on thresholds and cart subtotal
  await processFreebies(cartData);

  // Reinitialize carousels after cart changes
  // Use a small timeout to ensure DOM updates from cart operations are complete
  setTimeout(() => {
    if (window.CustomCarousel && typeof CustomCarousel.reinitializeAll === 'function') {
      console.log("Reinitializing carousels");
      CustomCarousel.reinitializeAll();
    }
  }, 200);
  
}, 150)); // Debounce for 150ms to reduce frequency

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Build updates object with all quantities set to 0
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = 0;
    });

    console.log("Removing add-ons with updates:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();
    console.log("Cart updated after removing add-ons:", updatedCartContent);

    // Dispatch cart change event to update the UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:remove",
          cart: updatedCartContent,
        },
      })
    );

    // Update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error removing add-ons:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
  if (!addons || addons.length === 0) return;

  console.log(`[syncAddonQuantities] Starting sync for ${addons.length} addons to quantity ${newQuantity}`);

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Update all addons to the new quantity
    const updates = {};
    addons.forEach((addon) => {
      console.log(`[syncAddonQuantities] Setting ${addon.handle} (key: ${addon.key}) to quantity ${newQuantity}`);
      updates[addon.key] = newQuantity;
    });

    console.log("[syncAddonQuantities] Updates object:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[syncAddonQuantities] Failed to update cart:", errorText);
      throw new Error("Failed to update cart");
    }

    const updatedCartContent = await response.json();
    console.log("[syncAddonQuantities] Cart successfully updated");

    // Dispatch a special event to prevent re-processing by the sync logic
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "addon-quantity:sync",
          cart: updatedCartContent,
        },
      })
    );

    // Force update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("[syncAddonQuantities] Error syncing addon quantities:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}
// Add this function to check and remove gift wrap and bag items when they're alone in cart
async function checkAndRemoveGiftWrappingItems(cartData) {
  // Check if cart has items
  if (!cartData || !cartData.items || cartData.items.length === 0) return;

  // Filter all gift wrap and bag items (items with _is_gift_wrap or _is_bag property)
  const giftWrapAndBagItems = cartData.items.filter(
    (item) => item.properties?._is_gift_wrap === 'Yes' || item.properties?._is_bag === 'Yes'
  );

  // Get all main products (items that are not add-ons, not gift wraps, not bags)
  const regularItems = cartData.items.filter(
    (item) => !item.properties?._main_product && 
              item.properties?._is_gift_wrap !== 'Yes' && 
              item.properties?._is_bag !== 'Yes'
  );

  console.log('Gift/Bag items count:', giftWrapAndBagItems.length);
  console.log('Main products count:', regularItems.length);
  console.log('Total items:', cartData.items.length);

  // If there are gift/bag items but NO regular items (only gifts/bags in cart), remove them
  if (giftWrapAndBagItems.length > 0 && regularItems.length === 0) {
    console.log('Only gift wrap and bag items in cart. Removing them...');
    
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Prepare updates to set gift wrap and bag items quantities to 0
      const updates = giftWrapAndBagItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      console.log('Removing gift/bag items with updates:', updates);

      // Update cart to remove gift wrap and bag items
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      });

      if (!response.ok) throw new Error("Failed to update cart");
      
      const updatedCartContent = await response.json();
      
      console.log('Successfully removed gift/bag items. Updated cart:', updatedCartContent);

      // Dispatch cart change event to update the UI
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "gift-items:auto-remove",
            cart: updatedCartContent,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    } catch (error) {
      console.error("Error removing gift wrap and bag items:", error);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      if (window.themeVariables?.settings.showErrorMessage) {
        alert(error.message);
      }
    }
  }
}


document.addEventListener('DOMContentLoaded', function () {
	const video = document.querySelector('.video-element');
	const muteToggle = document.getElementById('mute-toggle');
	const unmuteText = muteToggle.querySelector('.unmute-text');
	const muteText = muteToggle.querySelector('.mute-text');

	if (video && muteToggle) {
		// Toggle mute/unmute when the button is clicked
		muteToggle.addEventListener('click', function () {
			video.muted = !video.muted;

			// Toggle button text
			if (video.muted) {
				unmuteText.style.display = 'inline';
				muteText.style.display = 'none';
			} else {
				unmuteText.style.display = 'none';
				muteText.style.display = 'inline';
			}
		});

		// Toggle play/pause on video click
		video.addEventListener('click', function () {
			this.paused ? this.play() : this.pause();
		});
	}
});

// Size Chart Toggle in inches and cms
window.handleSizeToggle = function () {
	const tabs = document.querySelectorAll('.toggle-tab-inches-cm');
	tabs.forEach(tab => {
		tab.addEventListener('click', function() {
			const tabId = this.dataset.tab;
			// Remove active class from all tabs
			tabs.forEach(t => t.classList.remove('active'));
			// Add active class to clicked tab
			this.classList.add('active');
			// Hide all tab contents
			document.querySelectorAll('.tab-content-inches-cm').forEach(content => {
				content.style.display = 'none';
			});
			// Show the selected tab content
			document.getElementById(tabId).style.display = 'block';
		});
	});
};

window.handleSizeToggle();

window.handleSizeChartTabs = function() {
	const tabButtons = document.querySelectorAll('.size-chart-container .tab-button');
	const tabPanes = document.querySelectorAll('.size-chart-container .tab-pane');
	
	tabButtons.forEach(button => {
		button.addEventListener('click', function() {
			// Remove active class from all buttons and panes
			tabButtons.forEach(btn => btn.classList.remove('active'));
			tabPanes.forEach(pane => pane.classList.remove('active'));
			
			// Add active class to clicked button
			this.classList.add('active');
			
			// Show corresponding tab pane
			const tabId = this.getAttribute('data-tab');
			document.getElementById(tabId).classList.add('active');
		});
	});
};

// Call the function after DOM is loaded
document.addEventListener('DOMContentLoaded', window.handleSizeChartTabs);

document.addEventListener('DOMContentLoaded', function () {
  class ProductAddonCart extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.productHandle = this.dataset.productHandle;
      this.addEventListener('click', this.handleClick.bind(this));
      this.selectedVariantId = this.dataset.productSelectedVariant;

      // Store variant maps for addon products
      this.variantMaps = {};

      // Initialize variant maps
      this.initializeVariantMaps();

      // Set default values for selects if not already set
      this.setDefaultValues();

      this.setupEventListeners();
    }

    // Get and store variant information for all addons
    initializeVariantMaps() {
      // For pre-drape
      const preDrapeSection = this.querySelector('.pre-drape-section');
      if (preDrapeSection) {
        const variantMap = {};
        const dataAttr = preDrapeSection.getAttribute('data-variants');

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            console.log('Pre-drape variants data:', variantsData);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
              console.log(`Mapping pre-drape: ${variant.title} -> ${variant.id}`);
            });
          } catch (e) {
            console.error('Error parsing pre-drape variants', e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        // Store the map
        this.variantMaps['pre-drape'] = variantMap;
      }

      // For blouse customization
      const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
      if (blouseCustomizationSection) {
        const variantMap = {};
        const dataAttr = blouseCustomizationSection.getAttribute('data-variants');

        console.log('Blouse customization data-variants:', dataAttr);

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            console.log('Parsed blouse customization variants:', variantsData);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
              console.log(`Mapping blouse customization: ${variant.title} -> ${variant.id}`);
            });
          } catch (e) {
            console.error('Error parsing blouse customization variants', e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        console.log('Blouse customization variant map:', variantMap);
        // Store the map
        this.variantMaps['blouse-customization'] = variantMap;
      }

      // For all addon options
      this.querySelectorAll('.addon-option').forEach((addonOption, index) => {
        const variantMap = {};
        const dataAttr = addonOption.getAttribute('data-variants');

        if (dataAttr) {
          try {
            // Clean and parse JSON data from the data-variants attribute
            const cleanedDataAttr = dataAttr.replace(/\s+/g, ' ').trim();
            const variantsData = JSON.parse(cleanedDataAttr);
            variantsData.forEach((variant) => {
              variantMap[variant.title] = variant.id;
            });
          } catch (e) {
            console.error(`Error parsing addon variants for index ${index}`, e);
            console.error('Raw data attribute:', dataAttr);
          }
        }

        // Store the map
        this.variantMaps[`addon-${index}`] = variantMap;
      });
    }

    setDefaultValues() {
      // Don't set default values for dropdown selects
      // Just make sure they start with the empty option
      this.querySelectorAll('select').forEach((select) => {
        // Always reset to first option (usually "Choose a size")
        select.selectedIndex = 0;
      });
    }

    setupEventListeners() {
      // Pre-drape fields toggle
      const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
      const preDrapeFields = this.querySelector('.pre-drape-fields');
      const preDrapeMessageContainer = this.querySelector('.pre-drape-message-container');

      if (preDrapeCheckbox && preDrapeFields) {
        preDrapeCheckbox.addEventListener('change', () => {
          preDrapeFields.classList.toggle('hidden', !preDrapeCheckbox.checked);
          preDrapeMessageContainer.classList.toggle('hidden', !preDrapeCheckbox.checked);
          this.toggleAddToCartButton();
        });
      }

      // Toggle buttons for main options
      this.querySelectorAll('.addon-toggle-button').forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const targetClass = button.dataset.target;
          const targetContainer = this.querySelector(`.${targetClass}`);
          const icon = button.querySelector('.toggle-icon');
          
          if (targetContainer) {
            const isHidden = targetContainer.classList.contains('hidden');
            targetContainer.classList.toggle('hidden');
            button.classList.toggle('active');
            
            // Update icon
            if (icon) {
              icon.textContent = isHidden ? '−' : '+';
            }

            // Uncheck all nested checkboxes if collapsing
            if (!isHidden) {
              targetContainer.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
              });
            }

            this.toggleAddToCartButton();
          }
        });
      });

      // Blouse customization fields toggle
      const blouseCustomizationCheckbox = this.querySelector('.blouse-customization-checkbox');
      const blouseCustomizationFields = this.querySelector('.blouse-customization-fields');
      const blouseCustomizationMessageContainer = this.querySelector('.blouse-customization-message-container');

      if (blouseCustomizationCheckbox && blouseCustomizationFields) {
        blouseCustomizationCheckbox.addEventListener('change', () => {
          blouseCustomizationFields.classList.toggle('hidden', !blouseCustomizationCheckbox.checked);
          blouseCustomizationMessageContainer.classList.toggle('hidden', !blouseCustomizationCheckbox.checked);
          this.toggleAddToCartButton();
        });
      }

      // Individual nested option checkboxes (gift wrap, gift box, bags, addons)
      this.querySelectorAll('.gift-wrap-option-checkbox, .gift-box-option-checkbox, .bags-option-checkbox, .addon-checkbox').forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          if (checkbox.classList.contains('addon-checkbox')) {
            this.toggleAddonFields(checkbox);
          }
          this.updateToggleButtonState(checkbox);
          this.toggleAddToCartButton();
        });
      });

      // Remove cups fields toggle
      const removeCupsCheckbox = this.querySelector('.remove-cups-checkbox');
      const removeCupsMessageContainer = this.querySelector('.remove-cups-message-container');

      if (removeCupsCheckbox && removeCupsMessageContainer) {
        removeCupsCheckbox.addEventListener('change', () => {
          removeCupsMessageContainer.classList.toggle('hidden', !removeCupsCheckbox.checked);
          this.toggleAddToCartButton();
        });
      }
    }

    toggleAddonFields(checkbox) {
      const addonOption = checkbox.closest('.addon-option');
      const addonFields = addonOption.querySelector('.addon-fields');

      if (addonFields) {
        addonFields.classList.toggle('hidden', !checkbox.checked);
      }
    }

    updateToggleButtonState(checkbox) {
      // Find the parent container (gift-wrap-options, gift-box-options, bags-options, gifting-options, or addon-options)
      const optionsContainer = checkbox.closest('.gift-wrap-options, .gift-box-options, .bags-options, .gifting-options, .addon-options');
      
      if (!optionsContainer) return;

      // Find the corresponding toggle button
      const parentSection = optionsContainer.closest('.gift-wrap-container, .gift-box-container, .bags-container, .gifting-container, .addon-selection-container');
      
      if (!parentSection) return;

      const toggleButton = parentSection.querySelector('.addon-toggle-button');
      
      if (!toggleButton) return;

      // Check if any checkbox in this container is checked
      const anyChecked = optionsContainer.querySelector('input[type="checkbox"]:checked');
      
      // Update active class based on selection, but don't auto-hide the container
      if (!anyChecked) {
        toggleButton.classList.remove('active');
      } else {
        // Keep it active if any checkbox is checked
        toggleButton.classList.add('active');
      }
    }

    toggleAddToCartButton() {
      const isAnyCheckboxChecked =
        this.querySelector('.pre-drape-checkbox:checked') ||
        this.querySelector('.blouse-customization-checkbox:checked') ||
        this.querySelector('.addon-checkbox:checked') ||
        this.querySelector('.gift-wrap-option-checkbox:checked') ||
        this.querySelector('.gift-box-option-checkbox:checked') ||
        this.querySelector('.bags-option-checkbox:checked') ||
        this.querySelector('.remove-cups-checkbox:checked');

      const button = this.querySelector('.addon-submit-button');
      const mainATC = document.querySelector(
        '.product .product-info__block-item:is([data-block-type=buy-buttons])'
      );
      const mainContainer = document.querySelector('product-addon-cart .addon-container');

      if (button) {
        button.classList.toggle('hidden', !isAnyCheckboxChecked);
        mainContainer.classList.toggle('on-checked-container', isAnyCheckboxChecked);
        mainATC.classList.toggle('hidden', isAnyCheckboxChecked);
      }
    }

    validateFields() {
      let isValid = true;
      const errors = [];

      const preDrapeCheckbox = this.querySelector('.pre-drape-checkbox');
      if (preDrapeCheckbox?.checked) {
        const sizeSelect = this.querySelector('.pre-drape-size');
        if (!sizeSelect.value || sizeSelect.value === '') {
          errors.push('Please select a size for pre-drape service');
          isValid = false;
        }
      }

      const blouseCustomizationCheckbox = this.querySelector('.blouse-customization-checkbox');
      if (blouseCustomizationCheckbox?.checked) {
        const sizeSelect = this.querySelector('.blouse-customization-size');
        if (!sizeSelect.value || sizeSelect.value === '') {
          errors.push('Please select a size for blouse customization');
          isValid = false;
        }
      }

      if (!isValid) {
        alert(errors.join('\n'));
      }

      return isValid;
    }


    resetForm() {
      // Uncheck all checkboxes
      this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });

      // Reset all toggle buttons
      this.querySelectorAll('.addon-toggle-button').forEach((button) => {
        button.classList.remove('active');
        const icon = button.querySelector('.toggle-icon');
        if (icon) {
          icon.textContent = '+';
        }
      });

      // Reset all select elements except pre-drape-size and blouse-customization-size to their first options
      this.querySelectorAll('select').forEach((select) => {
        if (select.classList.contains('pre-drape-size') || select.classList.contains('blouse-customization-size')) {
          // For pre-drape-size and blouse-customization-size, set to the empty option
          select.value = '';
        } else if (select.options.length > 0) {
          // For other selects, use existing logic
          const selectedOption = select.querySelector('option[selected]');
          if (selectedOption) {
            select.value = selectedOption.value;
          } else {
            // Otherwise select first option
            select.selectedIndex = 0;
          }
        }
      });

      // Clear all input fields that are not selects
      this.querySelectorAll('input[type="number"], input[type="text"]').forEach((input) => {
        input.value = '';
      });

      // Hide all addon fields (update the list)
      this.querySelectorAll('.addon-fields, .pre-drape-fields, .blouse-customization-fields, .blouse-customization-message-container').forEach((field) => {
        field.classList.add('hidden');
      });

      // Hide all option containers
      this.querySelectorAll('.addon-options, .gift-wrap-options, .gift-box-options, .bags-options, .gifting-options').forEach((container) => {
        container.classList.add('hidden');
      });

      // Toggle the add-to-cart button
      this.toggleAddToCartButton();
    }

    async handleClick(event) {
      // Only handle the main add-to-cart submit button
      if (!event.target.matches('.addon-submit-button')) return;

      event.preventDefault();

      if (!this.validateFields()) return;

      // Add loading spinner to body
      document.body.classList.add('loading-spinner');

      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      try {
        await this.addProductsToCart();
      } catch (error) {
        console.error('Error adding products to cart:', error);
        alert(error.message || 'An error occurred while adding products to cart');
      } finally {
        document.body.classList.remove('loading-spinner');
        this.resetForm();
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }

    async addProductsToCart() {
      const mainProductTitle = this.productHandle;
      const mainProductQuantity = document.querySelector('input[name="quantity"]')?.value || 1;

      const items = [];

      // Add main product using stored variant ID
      items.push({
        id: this.selectedVariantId,
        quantity: parseInt(mainProductQuantity),
        properties: {}, // Will be populated based on selected addons
      });

      // Add pre-drape if selected
      const preDrapeSection = this.querySelector('.pre-drape-section');
      if (preDrapeSection && this.querySelector('.pre-drape-checkbox').checked) {
        const sizeSelect = this.querySelector('.pre-drape-size');
        const preDrapeMessage = this.querySelector('.pre-drape-message-input').value.trim();

        // Get the selected variant ID directly from the select value
        const variantId = sizeSelect.value;
        console.log('Selected pre-drape variant ID:', variantId);

        items.push({
          id: variantId,
          quantity: parseInt(mainProductQuantity), // Sync with main product quantity
          properties: {
            _main_product: mainProductTitle,
            ...(preDrapeMessage ? { instructions: preDrapeMessage } : {}),
          },
        });
        items[0].properties._has_pre_drape = 'Yes';
      }

      // Add blouse customization if selected
      const blouseCustomizationSection = this.querySelector('.blouse-customization-section');
      if (blouseCustomizationSection && this.querySelector('.blouse-customization-checkbox').checked) {
        const sizeSelect = this.querySelector('.blouse-customization-size');
        const blouseCustomizationMessage = this.querySelector('.blouse-customization-message-input').value.trim();

        // Get the selected variant ID directly from the select value
        const variantId = sizeSelect.value;
        console.log('Selected blouse customization variant ID:', variantId);

        items.push({
          id: variantId,
          quantity: parseInt(mainProductQuantity), // Sync with main product quantity
          properties: {
            _main_product: mainProductTitle,
            ...(blouseCustomizationMessage ? { instructions: blouseCustomizationMessage } : {}),
          },
        });
        items[0].properties._has_blouse_customization = 'Yes';
      }

      // Add addons if selected
      this.querySelectorAll('.addon-option').forEach((addonOption, index) => {
        const addonCheckbox = addonOption.querySelector('.addon-checkbox');
        if (addonCheckbox.checked) {
          const addonIndex = addonOption.dataset.addonIndex;
          const addonTitle = addonOption.dataset.productTitle;

          // Check if addon has size selection
          const sizeSelect = addonOption.querySelector('.addon-size');
          let selectedVariantId;

          if (sizeSelect && sizeSelect.value) {
            // For addon size, the value is already the variant ID
            selectedVariantId = sizeSelect.value;
          } else {
            // No size selected or no size select available
            // Try to parse the variants data attribute
            try {
              const variantsData = JSON.parse(addonOption.dataset.variants);
              if (variantsData && variantsData.length > 0) {
                selectedVariantId = variantsData[0].id;
              } else {
                throw new Error('No variants found');
              }
            } catch (e) {
              console.error('Error parsing addon variants:', e);
              alert('Error selecting addon variant. Please try again.');
              return;
            }
          }

          items.push({
            id: selectedVariantId,
            quantity: 1,
            properties: {
              _main_product: mainProductTitle,
              ...(sizeSelect && sizeSelect.value ? { size: sizeSelect.value } : {}),
            },
          });

          // Add property to main item to indicate addon
          items[0].properties._has_addon = 'Yes';
        }
      });

      // Add gift wrap options if selected (as independent products with _is_gift_wrap property)
      this.querySelectorAll('.gift-wrap-option').forEach((giftWrapOption) => {
        const giftWrapCheckbox = giftWrapOption.querySelector('.gift-wrap-option-checkbox');
        if (giftWrapCheckbox.checked) {
          const giftWrapVariantId = giftWrapOption.dataset.variantId;
          items.push({
            id: giftWrapVariantId,
            quantity: 1,
            properties: {
              _is_gift_wrap: 'Yes'
            }
          });
        }
      });

      // Add gift box options if selected (as independent products without properties)
      this.querySelectorAll('.gift-box-option').forEach((giftBoxOption) => {
        const giftBoxCheckbox = giftBoxOption.querySelector('.gift-box-option-checkbox');
        if (giftBoxCheckbox.checked) {
          const giftBoxVariantId = giftBoxOption.dataset.variantId;
          items.push({
            id: giftBoxVariantId,
            quantity: 1,
          });
        }
      });

      // Add bags options if selected (as independent products with _is_bag property)
      this.querySelectorAll('.bags-option').forEach((bagsOption) => {
        const bagsCheckbox = bagsOption.querySelector('.bags-option-checkbox');
        if (bagsCheckbox.checked) {
          const bagsVariantId = bagsOption.dataset.variantId;
          items.push({
            id: bagsVariantId,
            quantity: 1,
            properties: {
              _is_bag: 'Yes'
            }
          });
        }
      });

      // Add remove cups if selected
      const removeCupsSection = this.querySelector('.remove-cups-section');
      if (removeCupsSection && this.querySelector('.remove-cups-checkbox').checked) {
        const removeCupsMessage = this.querySelector('.remove-cups-message-input').value.trim();

        items.push({
          id: removeCupsSection.dataset.variantId,
          quantity: parseInt(mainProductQuantity), // Sync with main product quantity
          properties: {
            _main_product: mainProductTitle,
            ...(removeCupsMessage ? { instructions: removeCupsMessage } : {}),
          },
        });
        items[0].properties._has_remove_cups = 'Yes';
      }

      // Prepare sections for cart update
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      console.log('[Add to Cart] Items being added:', JSON.stringify(items, null, 2));

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (response.ok) {
        if (window.themeVariables.settings.cartType === 'page') {
          window.location.href = `${window.Shopify.routes.root}cart`;
          return;
        }

        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        // Dispatch cart events
        this.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );
      } else {
        // Handle different error formats from Shopify
        let errorMessage = responseJson.description || responseJson.message || 'Unable to add items to cart';
        
        // Check if there's a more detailed error message
        if (responseJson.errors) {
          if (typeof responseJson.errors === 'string') {
            errorMessage = responseJson.errors;
          } else if (typeof responseJson.errors === 'object') {
            errorMessage = Object.values(responseJson.errors).flat().join(', ');
          }
        }
        
        // Check for availability errors
        if (errorMessage.toLowerCase().includes('sold out') || 
            errorMessage.toLowerCase().includes('out of stock') || 
            errorMessage.toLowerCase().includes('not available')) {
          errorMessage = 'One or more items are currently out of stock. Please review your selections and try again.\n\nDetails: ' + errorMessage;
        }
        
        throw new Error(errorMessage);
      }
    }
  }

  customElements.define('product-addon-cart', ProductAddonCart);
});

// =====================
// Freebies functionality
// =====================

let __isProcessingFreebies = false;
const __freebieVariantCache = {};

function getFreebieConfig() {
  const settings = window.themeVariables?.settings;
  const config = settings?.freebiesConfig;
  if (!config || typeof config.enabled === 'undefined') return null;

  // Normalize items (filter invalid entries)
  const items = Array.isArray(config.items)
    ? config.items
        .filter((it) => it && typeof it.threshold === 'number' && it.handle)
        .map((it) => ({ threshold: it.threshold, handle: String(it.handle).trim() }))
    : [];

  return { enabled: !!config.enabled, items };
}

function isFreebieLineItem(item) {
  return item?.properties?._is_freebie === 'true';
}

async function getDefaultVariantId(productHandle) {
  if (!productHandle) return null;
  if (__freebieVariantCache[productHandle]) return __freebieVariantCache[productHandle];

  try {
    const res = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
    if (!res.ok) throw new Error('Failed to load product');
    const product = await res.json();
    const variant = product?.variants?.find((v) => v.available) || product?.variants?.[0];
    if (!variant) return null;
    __freebieVariantCache[productHandle] = variant.id;
    return variant.id;
  } catch (e) {
    console.warn('Freebie variant fetch failed for', productHandle, e);
    return null;
  }
}

async function addFreebieProducts(handles) {
  if (!handles || handles.length === 0) return null;

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  const items = [];
  for (const handle of handles) {
    const variantId = await getDefaultVariantId(handle);
    if (variantId) {
      items.push({
        id: variantId,
        quantity: 1,
        properties: { _is_freebie: 'true' },
      });
    }
  }

  if (items.length === 0) return null;

  const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      items,
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname,
    }),
  });

  const responseJson = await response.json();
  if (!response.ok) throw new Error(responseJson?.description || 'Failed to add freebies');

  const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
  cartContent.sections = responseJson.sections;

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart: cartContent },
    })
  );

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(cartContent);
  }

  return cartContent;
}

async function removeFreebieLineItems(itemsToRemove) {
  if (!itemsToRemove || itemsToRemove.length === 0) return null;

  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    })
  );

  const updates = {};
  itemsToRemove.forEach((item) => {
    updates[item.key] = 0;
  });

  const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({
      updates,
      sections: sectionsToBundle.join(','),
      sections_url: window.location.pathname,
    }),
  });

  const updatedCartContent = await response.json();
  if (!response.ok) throw new Error('Failed to remove freebies');

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'item:remove', cart: updatedCartContent },
    })
  );

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart && typeof cart.renderContents === 'function') {
    cart.renderContents(updatedCartContent);
  }

  return updatedCartContent;
}

async function processFreebies(cartData) {
  const cfg = getFreebieConfig();
  if (!cfg || !cfg.enabled) return;
  if (__isProcessingFreebies) return;

  try {
    __isProcessingFreebies = true;

    const subtotal = Math.round((cartData?.items_subtotal_price || 0) / 100);

    // Determine eligible freebies by threshold
    const eligibleHandles = Array.from(
      new Set(
        cfg.items
          .filter((it) => subtotal >= it.threshold)
          .map((it) => it.handle)
      )
    );

    const freebiesInCart = (cartData.items || []).filter((it) => isFreebieLineItem(it));
    const freebiesInCartHandles = freebiesInCart.map((it) => it.handle);

    const handlesToAdd = eligibleHandles.filter((h) => !freebiesInCartHandles.includes(h));
    const freebiesToRemove = freebiesInCart.filter((it) => !eligibleHandles.includes(it.handle));

    if (handlesToAdd.length === 0 && freebiesToRemove.length === 0) return;

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    // Remove first, then add, to avoid duplicates
    if (freebiesToRemove.length > 0) {
      await removeFreebieLineItems(freebiesToRemove);
    }

    if (handlesToAdd.length > 0) {
      await addFreebieProducts(handlesToAdd);
    }
  } catch (e) {
    console.warn('Freebies processing error:', e);
  } finally {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    __isProcessingFreebies = false;
  }
}